export default __webpack_public_path__ + "static/media/loading-background.db02bd53.png";